/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Voice_Agents_Inbound_Desc7Inputs */

const en_svc_ai_voice_agents_inbound_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Inbound_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every call answered in seconds, with greeting, intent detection and smart routing. No missed calls, no voicemail black holes.`)
};

const ar_svc_ai_voice_agents_inbound_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Inbound_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يتم الرد على كل مكالمة خلال ثوان، مع تحية وكشف النية وتوجيه ذكي. لا مكالمات فائتة ولا رسائل صوتية ضائعة.`)
};

const bn_svc_ai_voice_agents_inbound_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Inbound_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রতিটি কল সেকেন্ডের মধ্যে ধরা হয়, শুভেচ্ছা, উদ্দেশ্য শনাক্তকরণ আর স্মার্ট রাউটিং সহ। কোনো মিসড কল নেই, কোনো হারানো ভয়েসমেসেজ নেই।`)
};

const de_svc_ai_voice_agents_inbound_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Inbound_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeder Anruf wird in Sekunden beantwortet, mit Begrüßung, Absichtserkennung und intelligentem Routing. Keine verpassten Anrufe, keine verlorenen Mailbox-Nachrichten.`)
};

const es_svc_ai_voice_agents_inbound_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Inbound_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada llamada respondida en segundos, con saludo, detección de intención y enrutamiento inteligente. Sin llamadas perdidas ni mensajes de voz olvidados.`)
};

const fr_svc_ai_voice_agents_inbound_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Inbound_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque appel décroché en quelques secondes, avec accueil, détection d'intention et routage intelligent. Aucun appel manqué, aucun message vocal perdu.`)
};

const pt_svc_ai_voice_agents_inbound_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Inbound_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada chamada atendida em segundos, com saudação, detecção de intenção e roteamento inteligente. Sem chamadas perdidas nem mensagens de voz esquecidas.`)
};

const zh_svc_ai_voice_agents_inbound_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Inbound_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每个来电都在几秒内接听，带问候、意图识别和智能路由。不错过任何电话，不遗留任何语音留言。`)
};

const tr_svc_ai_voice_agents_inbound_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Inbound_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her çağrı saniyeler içinde yanıtlanır, karşılama, niyet algısı ve akıllı yönlendirme ile. Kaçan çağrı yok, kayıp sesli mesaj yok.`)
};

const ru_svc_ai_voice_agents_inbound_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Inbound_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Каждый звонок отвечен за секунды, с приветствием, распознаванием намерения и умной маршрутизацией. Никаких пропущенных звонков и потерянных голосовых сообщений.`)
};

const pl_svc_ai_voice_agents_inbound_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Inbound_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Każde połączenie odebrane w sekundy, z powitaniem, wykrywaniem intencji i inteligentnym routingiem. Żadnych straconych połączeń ani zagubionych wiadomości głosowych.`)
};

/**
* | output |
* | --- |
* | "Every call answered in seconds, with greeting, intent detection and smart routing. No missed calls, no voicemail black holes." |
*
* @param {Svc_Ai_Voice_Agents_Inbound_Desc7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_voice_agents_inbound_desc7 = /** @type {((inputs?: Svc_Ai_Voice_Agents_Inbound_Desc7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Voice_Agents_Inbound_Desc7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_voice_agents_inbound_desc7(inputs)
	if (locale === "bn") return bn_svc_ai_voice_agents_inbound_desc7(inputs)
	if (locale === "de") return de_svc_ai_voice_agents_inbound_desc7(inputs)
	if (locale === "es") return es_svc_ai_voice_agents_inbound_desc7(inputs)
	if (locale === "fr") return fr_svc_ai_voice_agents_inbound_desc7(inputs)
	if (locale === "pt") return pt_svc_ai_voice_agents_inbound_desc7(inputs)
	if (locale === "zh") return zh_svc_ai_voice_agents_inbound_desc7(inputs)
	if (locale === "tr") return tr_svc_ai_voice_agents_inbound_desc7(inputs)
	if (locale === "ru") return ru_svc_ai_voice_agents_inbound_desc7(inputs)
	if (locale === "pl") return pl_svc_ai_voice_agents_inbound_desc7(inputs)
	return en_svc_ai_voice_agents_inbound_desc7(inputs)
});
export { svc_ai_voice_agents_inbound_desc7 as "svc_ai-voice-agents_INBOUND_desc" }